export const environment = {
  endpoint: "https://api/",
  production: false,
  storage: "lucas-game",
  title: "Lucas",
};
